import React from 'react';
import { Dialog, T, useTranslation } from '@colonist/ui';
import { TextArea, TextInput, TextValidationWrapper } from '@colonist/ui-platform';
import { StarRating } from '../StarRating/StarRating.tsx';
import styles from './FeedbackStage.module.scss';
/** Stage 2 of the feedback form; description */ export function FeedbackStage({ open, rating, feedbackText, email, isLoggedIn, onRatingChange, onFeedbackTextChange, onEmailChange, onSubmit }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onSubmit
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.feedbackForm.improve'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.feedbackStage
    }, /*#__PURE__*/ React.createElement(StarRating, {
        value: rating,
        onChange: onRatingChange
    }), /*#__PURE__*/ React.createElement(TextValidationWrapper, {
        maxLength: 300
    }, ({ maxLength, onChange, ref })=>/*#__PURE__*/ React.createElement(TextArea, {
            ref: ref,
            maxLength: maxLength,
            placeholder: t('strings:popups.feedbackForm.examplePlaceholder'),
            value: feedbackText,
            onChange: (e)=>{
                onChange(e);
                onFeedbackTextChange(e.target.value);
            }
        })), !isLoggedIn && /*#__PURE__*/ React.createElement("div", {
        className: styles.emailField
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.emailLabel
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.feedbackForm.optionalEmail'
        }
    })), /*#__PURE__*/ React.createElement(TextInput, {
        type: "email",
        placeholder: "colonistplayer@gmail.com",
        value: email,
        onChange: (e)=>onEmailChange(e.target.value)
    })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onSubmit
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.feedbackForm.submit'
        }
    }))));
}
